/**
 * Picking a display label off a bilingual row.
 *
 * Every taxonomy and vocabulary row carries both `label_en` and `label_fa`
 * (catalog/serializers.py), so this is the only place that decides which one
 * shows. The fallback matters: a term the user adds is written into both
 * columns, but a seeded row could in principle be missing one.
 */
import { getLang, type Lang } from "./lang";

function choose(fa: string, en: string, lang: Lang): string {
  return lang === "fa" ? fa || en : en || fa;
}

/** An API row: ArtworkType, Subtype, Term, FacetCount. */
export function termLabel(
  row: { label_en: string; label_fa: string } | null | undefined,
  lang: Lang = getLang(),
): string {
  return row ? choose(row.label_fa, row.label_en, lang) : "";
}

/** A hand-written pair: fieldLabels.ts, PickerOption. */
export function pick(pair: { fa: string; en: string }, lang: Lang = getLang()): string {
  return choose(pair.fa, pair.en, lang);
}

/** Persian has its own comma; an English list must not inherit it. */
export function listSeparator(lang: Lang = getLang()): string {
  return lang === "fa" ? "، " : ", ";
}
